import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'; // 確保這是正確的 Vuetify 插件路徑
import router from './router'; // 如果有使用 Vue Router
import i18n from './i18n'; // 如果有使用 i18n

const app = createApp(App);

app.use(vuetify); // 使用 Vuetify
app.use(router); // 使用 Vue Router（如果有）
app.use(i18n); // 使用 i18n（如果有）

app.mount('#app'); // 掛載應用